import html2canvas from "html2canvas"
import { PDFHeader } from "../PDFHeader"
import { PDFFooter } from "../PDFFooter"

export const generateStagesPDF = async ({
  pdf,
  corporateData,
  stagesRef,
  stagesData
}) => {

    const element = stagesRef?.current
    if (!element) return

    const startY = await PDFHeader({ pdf, corporateData })

    pdf.setFontSize(14)
    pdf.setFont(undefined, "bold")
    pdf.text("Stages", 15, startY)

    pdf.setFontSize(10)
    pdf.setFont(undefined, "normal")
    pdf.text(
        "Data below shows the indication of stages of the candidates",
        15,
        startY + 6
    )

    const chartElement = element.querySelector(".stages-chart-export")

    const canvas = await html2canvas(chartElement, {
        scale: 2,
        useCORS: true,
    })

    const imgData = canvas.toDataURL("image/png")

    const pageWidth = pdf.internal.pageSize.getWidth()
    const pageHeight = pdf.internal.pageSize.getHeight()
    const maxImgWidth = pageWidth - 30
    const maxImgHeight = pageHeight * 0.45
    const minImgHeight = pageHeight * 0.30

    let imgWidth = maxImgWidth
    let imgHeight = (canvas.height * imgWidth) / canvas.width

    if (imgHeight > maxImgHeight) {
        imgHeight = maxImgHeight
        imgWidth = (canvas.width * imgHeight) / canvas.height
    }

    if (imgHeight < minImgHeight) {
        imgHeight = minImgHeight
        imgWidth = (canvas.width * minImgHeight) / canvas.height
        if (imgWidth > maxImgWidth) {
            imgWidth = maxImgWidth
        }
    }

    const imgX = (pageWidth - imgWidth) / 2
    pdf.addImage(imgData, "PNG", imgX, startY + 12, imgWidth, imgHeight)

    let currentY = startY + 12 + imgHeight + 10

    const stagesTableData = stagesData || [
        { stage: "Scheduled", count: 9037 },
        { stage: "Offered", count: 5083 },
        { stage: "Joined", count: 2992 },
        { stage: "Left", count: 368 },
    ]

    pdf.autoTable({
        startY: currentY,
        columns: [
            { header: "", dataKey: "roles" },
            { header: "Roles", dataKey: "count" },
        ],
        body: stagesTableData.map(item => ({
            roles: item.stage,
            count: item.count
        })),
        theme: "grid",
        styles: { fontSize: 10 },
        headStyles: {
            fillColor: [220, 220, 220],
            textColor: 0,
            fontStyle: "bold",
        },
        columnStyles: {
            roles: { cellWidth: 50 },
            count: { cellWidth: 120 }
        },
    })

    await PDFFooter({ pdf })
}